export const PROMOTION_CODE_MONTHLY = 'CODE_NOT_MONTHLY'
export const PROMOTION_CODE_FALSE_ARTICLES = 'Aggregated Exception: CODE IS INVALID FOR THIS ORDER.'
export const PROMOTION_CODE_INVALID = 'CODE_NOT_EXISTING'

export const TOTP_REQUIRED = 'TOTP_REQUIRED'
export const DEVICECOOKIE_REQUIRED = 'DEVICECOOKIE_REQUIRED'
export const INVALID_CREDENTIALS = 'INVALID_CREDENTIALS'



/** WEBPACK FOOTER **
 ** ./src/constants/Errors.js
 **/